<template>
	<div class='customer-link-component'>
		<div class="block">
	    <input class="input" type="text" v-model='link' readonly="readonly" @focus='dialogVisible = true'>
	  </div>
		<el-dialog title="编辑链接" :visible.sync="dialogVisible" :lock-scroll="false">
			<div class='dialog-wrap'>
				<el-select v-model="selectedOption" filterable placeholder="请选择" @change='optionChange'>
			    <el-option
			      v-for="(item,index) in linkOptions"
			      :key="index"
			      :label="item.name"
			      :value="item.value">
			    </el-option>
				</el-select>
			  <template v-for='item in params'>
			  	<div v-if='item.type == "text"' :key='item.key' class='margin-top'>
			  		<label v-if="item.name" class="label">{{item.name}}:</label>
			  		<el-input v-model="result[item.key]" placeholder="请输入内容"  @blur='changeAjax(item, result[item.key], true)' class='custom-input'></el-input>
			  	</div>
			  	<div v-if='!selectedOption' class='margin-top'><el-checkbox v-model="isAddSession">增加用户标识（自动拼接USERID和SESSION)</el-checkbox></div>
			  	<div v-if='item.type == "select"' :key='item.key' class='margin-top'>
			  		<label v-if="item.name" class="label">{{item.name}}:</label>
			  		<el-select v-model="result[item.key]" filterable placeholder="请选择">
					    <el-option
					      v-for="option in item.options"
					      :key="option.value"
					      :label="option.name"
					      :value="option.value">
					    </el-option>
					</el-select>
			  	</div>
			  </template>
			  <template v-if='childParams.type == "select"'>
			  	<el-select v-model="result[childParams.key]" filterable placeholder="请选择" class='margin-top'>
				    <el-option
				      v-for="option in childParams.options"
				      :key="option.value"
				      :label="option.name"
				      :value="option.value">
				    </el-option>
					</el-select>
			  </template>
		  </div>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="getLink">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script type="text/babel">
		import { stringToUrl, getQueryString } from 'UTILS/url'

		const SESSION_LINK = 'userId={userId}&session={session}'

		export default {
			data() {
				return {
					dialogVisible: false,
					linkOptions: [],
					selectedOption: '',
					childParams: {},
					result: {},
					customerLink: '',
					isAddSession: false
				}
			},
			props: {
				link: {
					type: String,
					default() {
						return ''
					}
				}
			},
			mounted() {
				this.getLinkOptions()
			},
			computed: {
				params() {
					let params = []
					let linkOptions = JSON.parse(JSON.stringify(this.linkOptions))
					linkOptions.forEach((item) => {
						if (item.value == this.selectedOption) {
							params = item.params
						}
					})
					return params 
				}
			},
			watch: {
				'link': function() {
					this.optionChange()
					this.initSelected()
				}
			},
			methods: {
				getLink() {
					if (this.selectedOption) {
						let link = "cyzs://" + this.selectedOption + '?'
						let hasAjaxUrl = false
						let showToast = false
						this.params.forEach((item) => {
							if (item.ajaxUrl) {
								hasAjaxUrl = true
							}
							if(this.result[item.key] || this.result[item.key]===0) {
								link += item.key + '=' + this.result[item.key] + '&'
							} else {
								showToast = true
							}
						})
						if (this.result[this.childParams.key]) {
							link +=  this.childParams.key + '=' + this.result[this.childParams.key] + '&'
						} else {
							if (hasAjaxUrl) {
								showToast = true
							}
						}
						if (showToast) {
							this.$message("请填写完整信息")
							return
						}
						this.dialogVisible = false
						this.$emit('update:link', link.substring(0, link.length-1))						
					} else {
						if (this.result.link) {
							if (this.isAddSession) {
								if (this.result.link.indexOf("?") > -1) {
									this.$emit('update:link', this.result.link + "&" + SESSION_LINK)
								} else {
									this.$emit('update:link', this.result.link + "?" + SESSION_LINK)
								}
							} else {
								this.$emit('update:link', this.result.link)
							}
							
							this.dialogVisible = false	
						} else {
							this.$message("请填写完整信息")
						}
					}
				},
				initSelected() {
					this.customerLink = this.link
					if (this.customerLink) {
						if (stringToUrl(this.customerLink) && stringToUrl(this.customerLink).hostname && stringToUrl(this.customerLink).protocol == "cyzs") {
							this.selectedOption = stringToUrl(this.customerLink).hostname
							this.params.forEach((item) => {
								// let value = JSON.parse(getQueryString(item.key, this.customerLink))
								let value = (getQueryString(item.key, this.customerLink)).toString()
								this.$set(this.result, item.key, value)
								this.changeAjax(item, value, false)
							})
						} else {
							if (this.customerLink.indexOf(SESSION_LINK) > -1) {
								this.isAddSession = true
								this.customerLink = this.customerLink.substring(0, this.customerLink.length - SESSION_LINK.length - 1)
							}
							if (this.params.length > 0) {
								this.$set(this.result, this.params[0].key, this.customerLink)
							}
							
						}
					}
				},
				getLinkOptions() {
					HttpRequest.get('/admin.php?method=link.getOptions').then((response) => {
					    this.linkOptions = _.toArray(response.data);
					    this.initSelected()
					});
				},
				optionChange() {
					this.result = {}
					this.childParams = {}
					this.customerLink = ''
				},
				changeAjax(obj, value, isEvent) {
					if (isEvent) {
						this.customerLink = ''
					}
					if (obj.ajaxUrl) {
						let params = {}
						params[obj.key] = value
						HttpRequest.get(`/admin.php${obj.ajaxUrl}`,params).then((response) => {
					    	this.childParams = response.data
					    	delete this.result[this.childParams.key]
					    	if (this.customerLink) {
					    		this.$set(this.result, this.childParams.key, JSON.parse(getQueryString(this.childParams.key, this.customerLink)))
							}
						});
					}
				}
			}
		}
</script>
<style lang="less" scoped>
.customer-link-component {
	.custom-input {
		width: 193px;
	}
	.dialog-wrap {
		width: 200px;
		margin: auto;
	}
}
</style>
